import React, { memo, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";

import folderIcon from '../../../assets/images/view.png';
import mapIcon from '../../../assets/images/map-icon.png';
import webPageIcon from '../../../assets/images/webpage.png';
import { setCurrentLayout, getLayoutInfo } from "../../../store/layouts/actions";
import { ViewType, ViewSgsType } from "../../../store/layouts/types";
import { ApplicationState } from "../../../store";
import { RouterState } from "connected-react-router";
import { resetBrowsePanes } from "../../../store/browse/actions";
import { APIState } from "../../../store/API/types";

import { isPresentObject, Routes } from '../../../types';
import { chooseService } from '../../../utils';

export interface LayoutItemViewInterface {
  style: {},
  view: ViewType | ViewSgsType,
  groupId: string,
}

const LayoutItemViewComponent: React.FC<LayoutItemViewInterface> = ({style, view, groupId}) => {
  const dispatch = useDispatch();
  const {currentLayout} = useSelector((state: ApplicationState) => state.layouts);
  const {username} = useSelector<ApplicationState, APIState>(state => state.API);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const flagForChecked = chooseService(
    () => {
      if (isPresentObject<ViewType>(view)) {
        return currentLayout && currentLayout.id === groupId && view.name === currentLayout.name
      }
    },
    () => {
      if (isPresentObject<ViewSgsType>(view)) {
        return currentLayout && currentLayout.id === view['a:EntityID'] && view['a:EntityName'] === currentLayout.name
      }
    }
  );
  const ref = useRef<HTMLDivElement>(null);
  const viewName = chooseService(
    () => isPresentObject<ViewType>(view) && view.name ? view.name : '',
    () => isPresentObject<ViewSgsType>(view) ? view['a:EntityName'] : ''
  );
  const listImg = chooseService(() => folderIcon, () => {
    if (isPresentObject<ViewSgsType>(view)) {
      switch (view['a:EntityType']) {
        case 'Map':
          return mapIcon;
        case 'WebPage':
          return webPageIcon;
        default:
          return folderIcon;
      }
    }
  });

  const handler = async () => {
    dispatch({type: 'cancelDeviceStatus'});

    chooseService(
      () => {
        if (ref.current && ref) {
          if (isPresentObject<ViewType>(view)) {
            dispatch(setCurrentLayout({id: groupId, view: view, layoutType: 'Layer'}, ref.current.offsetTop));
            window.localStorage.setItem(`${username}/layoutType`, `Layer`);
            window.localStorage.setItem(`${username}/layoutId`, `${groupId}/${view.name}`);
          }
        }
      },
      () => {
        if (ref.current && ref) {
          if (isPresentObject<ViewSgsType>(view)) {
            dispatch(getLayoutInfo(view['a:EntityID'], view["a:EntityType"], viewName, true, ref.current.offsetTop));
            window.localStorage.setItem(`${username}/layoutType`, view["a:EntityType"]);
            window.localStorage.setItem(`${username}/layoutId`, `${view['a:EntityID']}/${view["a:EntityName"]}`);
          }
        }
      }
    );

    location.pathname === Routes.browse && dispatch(resetBrowsePanes());
  };

  return (
    <li key={groupId + viewName}
        style={style}
    >
      <div className={`list-item-row list-view ${flagForChecked ? 'checked' : ''}`}
           id={`${groupId.replace(/[\\. ,:-]+/g, '')}${viewName.replace(/[\\. ,:-]+/g, '')}`}
           onClick={async () => await handler()}
           ref={ref}
      >
        <img src={listImg}
             alt="folder"
             height='12px'
             width='12px'
             className='m-r-5'
        />
        {viewName}
      </div>
    </li>
  )
};

export default memo(LayoutItemViewComponent)
